<div class="fluid grid">

  <div class="col-6 xl:col-6 sm:col-12">
    <app-companyselector [labelKey]="cliComLabel"
                         [parentCompany]="0"
                         [selectedID]="newDocument.DOCCLIENTSID"
                         [showTierBadge]="true"
                         (selectedCompanyID)="cliCompanySelected($event)"></app-companyselector>
  </div>
  <div class="col-6 xl:col-6 sm:col-12">
    <app-personselector [labelKey]="cliPerLabel" [parentCompany]="newDocument.DOCCLIENTSID" [disabled]="!newDocument.DOCCLIENTSID"
                        [selectedID]="newDocument.DOCPERSONID" [firstAvailable]="true"
                        (selectedPersonID)="cliPersonSelected($event)"></app-personselector>
  </div>
  <div class="col-6 xl:col-6 sm:col-12">
    <app-companyselector [labelKey]="pcoComLabel"
                         [parentCompany]="newDocument.DOCCLIENTSID"
                         [selectedID]="newDocument.DOCPCOCLIID"
                         (selectedCompanyID)="pcoCompanySelected($event)"></app-companyselector>
  </div>
  <div class="col-6 xl:col-6 sm:col-12">
    <app-personselector [labelKey]="pcoPerLabel" [parentCompany]="newDocument.DOCPCOCLIID" [disabled]="!newDocument.DOCPCOCLIID"
                        [selectedID]="newDocument.DOCPCOPERID" [firstAvailable]="true"
                        (selectedPersonID)="pcoPersonSelected($event)"></app-personselector>
  </div>

</div>
